import {
  HttpErrorResponse,
  type HttpHandlerFn,
  type HttpInterceptorFn,
  type HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OfficeDataAccess } from '@data-access/office.data-acces';
import { catchError, throwError } from 'rxjs';
import { AuthDataAccess } from '../../auth/data-access/auth.data-access';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const router = inject(Router);
  const authDataAccess = inject(AuthDataAccess);
  const userData = authDataAccess.getdataUser();
  const officeDataAccess = inject(OfficeDataAccess);

  if (userData) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${userData.token}`,
      },
    });
  }

  return next(request).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        authDataAccess.logOut();
        officeDataAccess.selectedOffice.set(undefined);
        router.navigateByUrl('/auth/sign-in');
      }

      return throwError(() => error);
    }),
  );
};
